import nrkP1 from "../assets/OurClients/nrk_p1.png";
import sca from "../assets/OurClients/sca.png";
import chum from "../assets/OurClients/chum.png";

export const ClientsReviews = [
    {
        name: "Bjørn Torre Grøtte, PD (NRK)",
        img: nrkP1,
        review: `RadioAnalyzer is of great benefit to me in my work every single day.
        
        The tools provide a very quick overview of the current market situation, but what’s more is that I can also zoom all the way in to a single hour or daypart and analyze in detail how it has developed over time.
        
        I often use the function Clocks to remind producers and hosts about stuff we all believe to be true, but that sometimes needs to be confirmed with actual data and fresh examples: like the fact that listeners will switch off if we talk for too long in a messy voicebreak on an uninteresting topic.
        
        I have used the tool on both the youth-focused channel NRK P3 that I was responsible for earlier, and on NRK P1, the biggest radio station in the country, for which I am now caretaker.
        
        Oh, and it’s an added bonus that the RadioAnalyzer tools make it easy for me to always know just how amazingly often the commercial radios play a Toto-song.`,
    },
    {
        name: "Christian Hall, Program Director, CHUM (Bell Media, Toronto)",
        img: chum,
        review: `One can never have too many tools when it comes to measuring listener habits and RadioAnalyzer continues to impress, becoming a more valuable tool in CHUM toolbox month after month.`,
    },
    {
        name: "Matthew OReilly, Head of Broadcast Content, SCA",
        img: sca,
        review: `Great radio has always been a combination of creativity, instinct and understanding your audience. What RadioAnalyzer gives us is another incredibly powerful layer - the ability to see how listeners are actually behaving in real time.
 
        For me, that’s what makes the platform so exciting. Instead of waiting days or weeks for traditional research, we can understand how audiences are responding to individual talk breaks, topics, music and programming decisions almost immediately. We can identify where listeners are engaging, where they’re switching off and, most importantly, use those insights to have better conversations with our content teams.
 
        The first time I saw RadioAnalyzer demonstrated, it genuinely felt like the future of radio research. It’s not about replacing the instincts of great programmers, producers or talent. It’s about giving them better information, faster, so they can make smarter decisions while keeping creativity at the heart of great radio.`,
    },
];
